module.exports = __webpack_public_path__ + "img/flag.f7a0fe0e.png";